import { Link } from 'react-router-dom';
import './Farms.css';

export default function Farms() {
  return (
    <div className="farms-page">
      <div className="farms-container">
        <div className="farms-header">
          <h1>Мои фермы</h1>
          <Link to="/farms/create" className="farms-create-button">
            + Создать ферму
          </Link>
        </div>
        <div className="farms-content">
          <p>Здесь будет список ферм</p>
        </div>
      </div>
    </div>
  );
}
